import { Editor } from "draft-js";
import { CSSProperties, FC, ReactNode, RefObject, useCallback } from "react";

import MainBlock from "@/components/organisms/pages/edit/MainBlock";
import {
  ConnectedService,
  ConnectedServiceTemplateOption,
  EditorModalProps,
  TemplateOptionProp,
} from "@/hooks/useTemplatePartsEditor";
import { TemplatePart } from "@/states/page-editor/template-parts/types";

interface Props {
  editorRef?: RefObject<Editor>;
  templatePartsEditor: ReactNode;
  bgStyle: CSSProperties;
  textBaseStyle?: CSSProperties;
  connectedService: ConnectedService | undefined;
  mainBlock?: TemplatePart;
  isShowMainBlock?: boolean;
  setConnectedService: (
    key: string,
    service?: ConnectedServiceTemplateOption,
  ) => void;
  setMainBlock: (mainBlock: TemplatePart | undefined) => void;
  setEditorModalPrpps: (props: EditorModalProps) => void;
  renderEditorModal: () => ReactNode;
}

export const PageEdit: FC<Props> = ({
  editorRef,
  templatePartsEditor,
  bgStyle,
  textBaseStyle,
  connectedService,
  mainBlock,
  isShowMainBlock,
  setConnectedService,
  setMainBlock,
  setEditorModalPrpps,
  renderEditorModal,
}) => {
  const onFocus = useCallback(() => {
    editorRef?.current?.focus();
  }, [editorRef?.current]);

  return (
    <article
      className={`flex min-h-screen relative w-full overflow-x-hidden pt-[64px] px-5 md:px-0`}
      onClick={onFocus}
    >
      <div className="w-full">
        <div className="pb-[600px] w-full min-h-full" style={bgStyle}>
          {/* メインブロック */}
          {isShowMainBlock && (
            <MainBlock
              part={mainBlock}
              onChange={(
                value: TemplatePart | undefined,
                key?: string,
                options?: TemplateOptionProp,
              ) => {
                // 連携サービスの更新
                if (options?.service && key) {
                  setConnectedService(
                    key,
                    value && options.service.serviceId
                      ? {
                          serviceId: options.service.serviceId,
                        }
                      : undefined,
                  );
                }
                setMainBlock(value);
              }}
              connectedService={connectedService}
              setEditorModalPrpps={setEditorModalPrpps}
            />
          )}

          {/* 本文 */}
          <div style={textBaseStyle}>{templatePartsEditor}</div>
          {renderEditorModal()}
        </div>
      </div>
    </article>
  );
};
